import { ITemplate } from '@/interfaces/template';

export const printTemplates: ITemplate[] = [
  {
    key: 'TM01',
    name: 'ใบส่งของ ต้นฉบับบริษัท',
  },
  {
    key: 'TM02',
    name: 'ใบส่งของ สำเนาบริษัท',
  },
  {
    key: 'TM03',
    name: 'ใบส่งของ สำเนาลูกค้า',
  },
  {
    key: 'TM04',
    name: 'ใบแจ้งหนี้ ต้นฉบับลูกค้า',
  },
  {
    key: 'TM05',
    name: 'ใบแจ้งหนี้ สำเนาลูกค้า',
  },
  {
    key: 'TM05-2',
    name: 'ใบแจ้งหนี้ สำเนาบริษัท',
  },
  {
    key: 'TM06',
    name: 'ใบกำกับภาษี ต้นฉบับลูกค้า',
  },
  {
    key: 'TM07',
    name: 'ใบกำกับภาษี สำเนาลูกค้า',
  },
  {
    key: 'TM07-2',
    name: 'ใบกำกับภาษี สำเนาบริษัท',
  },
  {
    key: 'TM08',
    name: 'ใบกำกับสินค้า ต้นฉบับลูกค้า',
  },
  {
    key: 'TM09',
    name: 'ใบกำกับสินค้า สำเนาบริษัท',
  },
  {
    key: 'TM10',
    name: 'ใบเสร็จรับเงิน ต้นฉบับลูกค้า',
  },
  {
    key: 'TM11',
    name: 'ใบเสร็จรับเงิน สำเนาบริษัท (1)',
  },
  {
    key: 'TM11-2',
    name: 'ใบเสร็จรับเงิน สำเนาบริษัท (2)',
  },
  {
    key: 'TM12',
    name: 'ใบเบิกสินค้า',
  },
  {
    key: 'TM13',
    name: 'ใบส่งสินค้าชั่วคราว ต้นฉบับบริษัท',
  },
  {
    key: 'TM14',
    name: 'ใบส่งสินค้าชั่วคราว สำเนาบริษัท',
  },
  {
    key: 'TM15',
    name: 'ใบส่งสินค้าชั่วคราว สำเนาลูกค้า',
  },
  {
    key: 'TM16',
    name: 'ใบส่งของจากลูกค้า',
  },
  {
    key: 'TM17',
    name: 'เอกสาร COA',
  },
  {
    key: 'TM18',
    name: 'เอกสารอ้างอิง PO',
  },
  {
    key: 'TM19',
    name: 'PROFORMA INVOICE',
  },
  {
    key: 'TM20',
    name: 'Commercial Invoice',
  },
  {
    key: 'TM21',
    name: 'Sale Contract',
  },
  {
    key: 'TM22',
    name: 'PROFORMA INVOICE',
  },
  {
    key: 'TM23',
    name: 'Packing List',
  },
  {
    key: 'TM31',
    name: 'ใบวางบิล',
  },
];
